import { render, staticRenderFns } from "./BaseSelectBackground.vue?vue&type=template&id=b83c0a58&"
import script from "./BaseSelectBackground.vue?vue&type=script&lang=js&"
export * from "./BaseSelectBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports